var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import { MultipleSelectOption } from "multiple-select-vanilla";
import { ExtendedMultipleSelectInstance } from "./extended-multiple-select-instance";
import English from "./locales/multiple-select-en-US";
import Constants from "./constants";
export const multipleSelect = (selector, config = {}) => {
  if (typeof selector === "string") {
    return _multipleSelect(document.querySelectorAll(selector), config);
  }
  if (selector instanceof Node) {
    return _multipleSelect([selector], config);
  }
  return _multipleSelect(selector, config);
};
function _multipleSelect(nodeList, config) {
  const nodes = Array.from(nodeList);
  const instances = [];
  for (let i = 0; i < nodes.length; i++) {
    const node = nodes[i];
    try {
      if (node._multipleSelect !== void 0) {
        node._multipleSelect.destroy();
        delete node._multipleSelect;
      }
      node._multipleSelect = new ExtendedMultipleSelectInstance(
        node,
        config || {}
      );
      node._multipleSelect.init();
      const msOptions = node._multipleSelect.getOptions(false);
      msOptions.onHardDestroy = () => delete node._multipleSelect;
      msOptions.onAfterHardDestroy = () => instances[i] = null;
      instances.push(node._multipleSelect);
    } catch (e) {
      console.error(e);
    }
  }
  return instances.length === 1 ? instances[0] : instances;
}
multipleSelect.defaults = Constants.DEFAULTS;
multipleSelect.locales = __spreadValues({}, English);
multipleSelect.methods = Constants.METHODS;
if (window !== void 0) {
  window.multipleSelect = multipleSelect;
}
